import React from 'react';
import PropTypes from 'prop-types';
import { 
  Tabs, 
  Tab, 
  Box, 
  Grid, 
} from '@material-ui/core';

function TabsControl({
  tabs = [],
  value = 0,
  onChange,
  settings = {},
  spacing = 2,
  renderFields,
}) {
  const activeValue = tabs[value] ? value : 0;
  const {
    indicatorColor = 'primary',
    scrollButtons,
    textColor = 'primary',
    variant = 'fullWidth',
  } = settings;

  return (
    <Grid item xs={12} style={{ 
      marginBottom: 16, 
    }}>
      <Tabs
        value={activeValue}
        onChange={(_, newValue) => onChange(newValue)}
        variant={variant}
        scrollButtons={scrollButtons}
        indicatorColor={indicatorColor}
        textColor={textColor}
      >
        {tabs.map((tab, idx) => (
          <Tab key={idx} label={tab.label} />
        ))}
      </Tabs>
      <Box mt={2}>
        <Grid container spacing={spacing}>
          {renderFields(tabs[activeValue]?.fields || [], `tab${activeValue}_`)}
        </Grid>
      </Box>
    </Grid>
  );
}

TabsControl.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      fields: PropTypes.array.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  settings: PropTypes.shape({
    indicatorColor: PropTypes.oneOf(['primary', 'secondary']),
    scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'on', 'off']),
    textColor: PropTypes.oneOf(['primary', 'secondary', 'inherit']),
    variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard']),
  }),
  spacing: PropTypes.number,
  renderFields: PropTypes.func.isRequired,
};

export default TabsControl;
